import { apiSlice } from "../api/apiSlice";

export const quizzesAPI = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQuizzes: builder.query({
      query: () => "/quizzes",
    }),
    getQuiz: builder.query({
      query: (id) => `/quizzes/${id}`,
    }),
    getQuizzesOfVideo: builder.query({
      query: (video_id) => `/quizzes?video_id=${video_id}`,
    }),
    addQuiz: builder.mutation({
      query: (data) => ({
        url: "/quizzes",
        method: "POST",
        body: data,
      }),

      async onQueryStarted(data, { queryFulfilled, dispatch }) {
        try {
          const addResult = await queryFulfilled;
          dispatch(
            apiSlice.util.updateQueryData("getQuizzes", undefined, (draft) => {
              draft.push(addResult.data);
            })
          );
        } catch (error) {
          console.error("Something Went Wrong!");
          console.error(error);
        }
      },
    }),
    editQuiz: builder.mutation({
      query: ({ id, data }) => ({
        url: `/quizzes/${id}`,
        method: "PATCH",
        body: data,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const editResult = await queryFulfilled;

          //Update Tasks Cache
          await dispatch(
            apiSlice.util.updateQueryData("getQuizzes", undefined, (draft) => {
              let target = draft.findIndex(
                (assignment) => Number(assignment.id) === arg.id
              );
              draft[target] = editResult.data;
            })
          );

          //Update quiz Cache for edit
          const id = String(arg.id);
          await dispatch(
            apiSlice.util.updateQueryData("getQuiz", id, (draft) => {
              draft.question = editResult.data.question;
              draft.video_id = editResult.data.video_id;
              draft.video_title = editResult.data.video_title;
              draft.options = editResult.data.options;
            })
          );
        } catch (error) {
          console.error("Something went Wrong!");
        }
      },
    }),
    deleteQuiz: builder.mutation({
      query: (id) => ({
        url: `quizzes/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        const deleteResult = dispatch(
          apiSlice.util.updateQueryData("getQuizzes", undefined, (draft) => {
            const targetIndex = draft.findIndex(
              (assignment) => Number(assignment.id) === arg
            );
            draft.splice(targetIndex, 1);
          })
        );

        try {
          const result = await queryFulfilled;
          if (result.meta.response.status === 200) {
            console.log("Successfully Deleted!");
          }
        } catch (error) {
          deleteResult.undo();
          console.log(error);
        }
      },
    }),
  }),
});

export const {
  useGetQuizzesQuery,
  useGetQuizQuery,
  useGetQuizzesOfVideoQuery,
  useAddQuizMutation,
  useEditQuizMutation,
  useDeleteQuizMutation,
} = quizzesAPI;
